const SUPER_ADMIN_VIEW_KEY = "viewAsSuperAdmin";

const getStoredUserData = () => {
  try {
    return JSON.parse(localStorage.getItem("userdata") || "{}");
  } catch (error) {
    console.error("Failed to parse stored user data for view mode:", error);
    return {};
  }
};

export const isSuperAdminUser = () => {
  const userData = getStoredUserData();
  return userData?.role === "SuperAdmin";
};

export const getIsSuperAdminView = () => {
  if (!isSuperAdminUser()) {
    return false;
  }
  const saved = localStorage.getItem(SUPER_ADMIN_VIEW_KEY);
  if (saved === null) {
    return true;
  }
  return saved === "true";
};

export const setIsSuperAdminView = (enabled) => {
  localStorage.setItem(SUPER_ADMIN_VIEW_KEY, String(Boolean(enabled)));
};
